import React from 'react';
import { compose, withState, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { StoreState } from '@mm/state/store-interfaces';
import RssFeedModel from '@mm/state/model/RssFeedModel';
import { DEFAULT_LINK_LABEL } from '../../constants/texts';
import RssFeedCRUDActions from '@mm/state/actions/RssFeedCRUDActions';
import TextInput from '../../../../../common/components/TextInput';
import './RssFeedDetails.scss';

type OnLinkChange = () => { linkButtonLabel: string };
type SetLinkButtonLabel = (linkButtonLabel: string) => void;
type PropsFromWithState = {
  linkButtonLabel: string;
  setLinkButtonLabel: SetLinkButtonLabel;
};
type PropsFromWithHandler = {
  onLinkChange: ReturnType<typeof onLinkChange>;
};
type PropsFromDispatch = ReturnType<typeof mapDispatchToProps>;

type InnerProps = OnLinkChange &
  PropsFromDispatch &
  PropsFromWithState &
  PropsFromWithHandler;

type OuterProps = {
  feed: RssFeedModel;
  chatbotId: number;
};

type OwnProps = OuterProps & PropsFromWithHandler & PropsFromWithState;

type Props = OuterProps & InnerProps;

const mapDispatchToProps = (
  dispatch: Dispatch<StoreState>,
  ownProps: OwnProps,
) => ({
  updateFeed: () => {
    const { feed, chatbotId } = ownProps;
    const label = ownProps.linkButtonLabel && ownProps.linkButtonLabel.trim();
    if (feed.linkButtonLabel !== label) {
      const nextLabel = label || DEFAULT_LINK_LABEL;
      const newFeed = Object.assign({}, feed, { linkButtonLabel: nextLabel });
      ownProps.setLinkButtonLabel(nextLabel);
      return dispatch(RssFeedCRUDActions.update(chatbotId, newFeed));
    }
    return null;
  },
});

const LinkTextInput = (props: Props) => {
  const { linkButtonLabel, onLinkChange, updateFeed } = props;
  return (
    <div className="feed-details__input-container">
      <div className="feed-details__field-title">Link to Post Button Text</div>
      <TextInput
        maxLength={20}
        className="feed-details__feed-name"
        value={linkButtonLabel}
        onChange={onLinkChange}
        onBlur={updateFeed}
        onMouseLeave={updateFeed}
      />
    </div>
  );
};

const onLinkChange =
  ({ setLinkButtonLabel }: PropsFromWithState) =>
  e =>
    setLinkButtonLabel(e.target.value);

const enhance = compose<InnerProps, OuterProps>(
  withState(
    'linkButtonLabel',
    'setLinkButtonLabel',
    ({ feed: { linkButtonLabel } }) => linkButtonLabel,
  ),
  withHandlers<Props, {}>({ onLinkChange }),
  connect(null, mapDispatchToProps),
);

export default enhance(LinkTextInput);
